module.exports = __webpack_public_path__ + "img/cl.fb98c67b.svg";